module.exports = __webpack_public_path__ + "img/play-icon.996bd413.svg";